import { useQuery } from '@tanstack/react-query';
import wpcom, { APIError } from 'lib/wpcom-api';
import useOauth from 'data/oauth/use-oauth';

export interface StripeConfiguration {
	public_key: string;
	js_url: string;
}

const query = ( token = '' ) => {
	return wpcom( token )
		.get<StripeConfiguration>( '/wpcom/v2/host-partners/wpcloud/stripe/configuration' )
		.then( response => response.data );
};

export default function useWPCloudStripeConfigurationQuery() {
	const { oauth } = useOauth();
	return useQuery<StripeConfiguration, APIError, StripeConfiguration>( {
		queryKey: [ 'stripe', 'configuration' ],
		queryFn: () => query( oauth.accessToken ),
		staleTime: Infinity,
		gcTime: Infinity,
	} );
}
